/* Recently viewed — custom tracker (All Star Elite).
   Stores product IDs newest-first in localStorage, excludes the product being viewed,
   keeps the last 20, shows up to 12. Sold-out items are filtered in the section Liquid. */
if (!customElements.get("recently-viewed-products")) {
  customElements.define(
    "recently-viewed-products",
    class RecentlyViewedProducts extends HTMLElement {
      static KEY = "ase-recently-viewed";
      static MAX_STORED = 20;
      static MAX_SHOWN = 12;

      connectedCallback() {
        this.section = this.closest(".f-recently-viewed");
        this.currentId = parseInt(this.dataset.productId) || null;
        this.items = this.readItems();
        this.record();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this.section);
          this.init();
        };
        new IntersectionObserver(handleIntersection, {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this.section);
      }

      readItems() {
        try {
          const raw = JSON.parse(window.localStorage.getItem(RecentlyViewedProducts.KEY) || "[]");
          return Array.isArray(raw) ? raw.map((x) => parseInt(x)).filter(Boolean) : [];
        } catch (e) {
          return [];
        }
      }

      record() {
        if (!this.currentId) return;
        const next = [this.currentId, ...this.items.filter((id) => id !== this.currentId)].slice(
          0,
          RecentlyViewedProducts.MAX_STORED
        );
        try {
          window.localStorage.setItem(RecentlyViewedProducts.KEY, JSON.stringify(next));
        } catch (e) {}
      }

      getQueryString() {
        return this.items
          .filter((id) => id !== this.currentId)
          .slice(0, RecentlyViewedProducts.MAX_SHOWN)
          .map((id) => "id:" + id)
          .join(" OR ");
      }

      hide() {
        this.section && this.section.classList.add("f-hidden");
        this.classList.add("f-hidden");
      }

      init() {
        const q = this.getQueryString();
        if (!q) return this.hide();

        fetch(this.dataset.url + encodeURIComponent(q))
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("recently-viewed-products");
            if (!recommendations) return this.hide();
            this.productsCount = recommendations.querySelectorAll(".product-card").length;
            if (this.productsCount <= 0) return this.hide();

            this.innerHTML = recommendations.innerHTML;
            const productContainer = this.querySelector(".f-recently-viewed-flickity");
            const { enableSlider, sliderColumns, sliderColumnsTablet } = productContainer.dataset;
            let activeColumns =
              FoxThemeSettings.isTablet && sliderColumnsTablet ? sliderColumnsTablet : sliderColumns;
            activeColumns = parseInt(activeColumns);

            if (enableSlider === "true" && !FoxThemeSettings.isMobile) {
              if (this.productsCount > activeColumns) {
                this.slider = new window.FoxTheme.Slider(productContainer);
              } else {
                productContainer.classList.remove("md:flickity-enable");
                productContainer.classList.add("flickity-destroyed");
              }
            }
            if (typeof __reInitTooltip === "function") __reInitTooltip(productContainer);
          })
          .catch((e) => {
            console.error(e);
            this.hide();
          });
      }
    }
  );
}
